"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPqlFormAttributes = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _formAttributes = require("ui-addon-upgrades/_core/pql/formAttributes");

var getPqlFormAttributes = function getPqlFormAttributes() {
  var isProd = _enviro.default.getShort() === 'prod';

  if (!isProd) {
    return _formAttributes.QA_PQL_FORM_ATTRIBUTES;
  }

  return _formAttributes.PRODUCTION_PQL_FORM_ATTRIBUTES;
};

exports.getPqlFormAttributes = getPqlFormAttributes;